import { render, staticRenderFns } from "./ModelTreatment.vue?vue&type=template&id=f6ee0aea"
import script from "./ModelTreatment.vue?vue&type=script&lang=js"
export * from "./ModelTreatment.vue?vue&type=script&lang=js"
import style0 from "./ModelTreatment.vue?vue&type=style&index=0&id=f6ee0aea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports